import PropTypes from 'prop-types';
import React from 'react';
import {Card, CardHeader, IconButton} from '@mui/material';
import {Close as CloseIcon} from '@mui/icons-material';

const FileListItem = ({file, onRemoveFile}) => {
  let fileSize = 0;
  file.files.forEach(f => {
    fileSize = fileSize + f.size;
  });
  return (
    <Card
      sx={{
        width: '100%',
        marginBottom: 1,
      }}
      elevation={2}
    >
      <CardHeader
        action={
          <IconButton
            onClick={() => onRemoveFile(file)}
            data-testid="removeFileBtn"
          >
            <CloseIcon />
          </IconButton>
        }
        title={file.label}
        titleTypographyProps={{variant: 'body1'}}
        subheader={
          <React.Fragment>
            {file.files.length > 1 &&
              `Components: ${file.files.map(f => f.name).join(', ')}`}
          </React.Fragment>
        }
        subheaderTypographyProps={{variant: 'body2', color: 'textSecondary'}}
      />
    </Card>
  );
};

FileListItem.propTypes = {
  file: PropTypes.object.isRequired,
  onRemoveFile: PropTypes.func,
};

export default FileListItem;
